import { type FC, memo } from 'react';

import { Button } from '@livechat/design-system-react-components';

import * as styles from '../styles';

interface Props {
  onClick: () => void;
}

export const Context25ActionButton: FC<Props> = memo(({ onClick }) => {
  return (
    <Button className={styles.buttonStyle} onClick={onClick} kind="plain" size="compact">
      Discover Text App
    </Button>
  );
});

Context25ActionButton.displayName = 'Context25ActionButton';
